import { Grid, useTheme } from "@mui/material";
import { RemoveCircle, CheckCircle, Cancel, Info } from "@mui/icons-material";

export type Action = {
    action: string;
    status: string;
};

export type ImportActionWidgetProps = {
    action: Action;
};

type ImportActionStatusIconProps = {
    action: Action;
};

function ImportActionStatusIcon(props: ImportActionStatusIconProps) {
    const theme = useTheme();
    const sx = { mt: -0.25 };
    switch (props.action.status.toLowerCase()) {
        case "planned":
            return (<Info htmlColor={theme.palette.info.main} sx={sx} />);
        case "succeeded":
            return (<CheckCircle htmlColor={theme.palette.success.main} sx={sx} />);
        case "failed":
            return (<Cancel htmlColor={theme.palette.error.main} sx={sx} />);
        default:
            return (<RemoveCircle htmlColor={theme.palette.warning.main} sx={sx} />);
    }
}

function ImportActionWidget(props: ImportActionWidgetProps) {
    const icon = <ImportActionStatusIcon action={props.action} />;
    return (
    <Grid container alignItems="top" wrap="nowrap" spacing={1}>
        <Grid item>
            {icon}
        </Grid>
        <Grid item sx={{ whiteSpace: "pre-wrap" }}>
            {props.action.action}
        </Grid>
    </Grid>);
}

export default ImportActionWidget;